<template>
    <div v-if="doc" class="d-flex flex-wrap align-center">
        <template v-for="answer in answered">
            <span class="text-sm mr-2" :key="`${answer.key}-label`">{{ answer.title }}</span>
            <v-chip v-if="answer.chip" class="mr-6" :key="`${answer.key}-value`">{{ answer.value }}</v-chip>
            <span v-else class="mr-6" :key="`${answer.key}-value`">{{ answer.value }}</span>
        </template>
    </div>
</template>

<script>
import { answers } from "@/utils/surveyFields";

export default {
    name: "TilesResultsCore",
    props: {
        doc: {
            type: Object,
            default: () => { },
        },
        // step 1 field definitions from the project content file
        fields: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        // every answer on the response, declared in the content file or not
        answered() {
            return answers(this.doc, this.fields);
        },
    },
};
</script>
